var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2.75C10.0716 2.75 8.18657 3.32183 6.58319 4.39317C4.97982 5.46451 3.73013 6.98726 2.99218 8.76884C2.25422 10.5504 2.06114 12.5108 2.43735 14.4021C2.81355 16.2934 3.74215 18.0307 5.10571 19.3943C6.46928 20.7579 8.20656 21.6865 10.0979 22.0627C11.9892 22.4389 13.9496 22.2458 15.7312 21.5078C17.5127 20.7699 19.0355 19.5202 20.1068 17.9168C21.1782 16.3134 21.75 14.4284 21.75 12.5C21.7468 9.91513 20.7185 7.43705 18.8907 5.60927C17.063 3.78149 14.5849 2.75323 12 2.75ZM15.75 13.25H12.75V16.25C12.75 16.4489 12.671 16.6397 12.5303 16.7803C12.3897 16.921 12.1989 17 12 17C11.8011 17 11.6103 16.921 11.4697 16.7803C11.329 16.6397 11.25 16.4489 11.25 16.25V13.25H8.25C8.05109 13.25 7.86033 13.171 7.71967 13.0303C7.57902 12.8897 7.5 12.6989 7.5 12.5C7.5 12.3011 7.57902 12.1103 7.71967 11.9697C7.86033 11.829 8.05109 11.75 8.25 11.75H11.25V8.75C11.25 8.55109 11.329 8.36032 11.4697 8.21967C11.6103 8.07902 11.8011 8 12 8C12.1989 8 12.3897 8.07902 12.5303 8.21967C12.671 8.36032 12.75 8.55109 12.75 8.75V11.75H15.75C15.9489 11.75 16.1397 11.829 16.2803 11.9697C16.421 12.1103 16.5 12.3011 16.5 12.5C16.5 12.6989 16.421 12.8897 16.2803 13.0303C16.1397 13.171 15.9489 13.25 15.75 13.25Z",
    fill: "#343330"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusCircle);
export default __webpack_public_path__ + "static/media/PlusCircle.c6f5150d5d841c80423249a019c2d2cd.svg";
export { ForwardRef as ReactComponent };